export const FormularioFact = {    
  urls: {
    path: "/facturacion/tipo-persona",        
  },
  CONSTANTES : {
    TIPO_PERSONA: {
      FISICA: 'F',
      MORAL: 'J',
    },
    REQUIERE_FACTURA: { 
      SI: 'SI', 
      NO: 'NO' 
    },
    ACCION_REALIZADA: { 
      QR: 'escaneoQr', 
      PDF: 'subirPdf' ,
      MANUAL: 'llenarManualmente' 
    },
  }
};


